import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  '& .APDContainer': {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2),
    },
  },
  '& .APDTextSection': {
    width: theme.spacing(70.25),
    [theme.breakpoints.down('xl')]: {
      width: theme.spacing(63.5),
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  '& .secondaryMainColor': {
    color: theme.palette.secondary.main,
  },
  '& .APDDescText': {
    paddingBottom: theme.spacing(3),

    '& a': {
      color: theme.palette.primary.main,
      fontWeight: 700,
    },
    '& br': {
      content: '""',
      display: 'block !important',
      marginBottom: theme.spacing(2.625),
    },
  },

  '& .APDTHeaderText': {
    paddingBottom: theme.spacing(2),
  },
  '& .APDTabsContiner': {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  '& .APDTabs': {
    minHeight: 'unset',
    position: 'relative',
    bottom: '-1px',
    '& .MuiTabScrollButton-root': {
      display: 'none',
    },
    '& .MuiTab-root': {
      borderBottom: '0px',
      minWidth: 'unset',
      minHeight: 'unset',
      color: theme.palette.grey[300],
      letterSpacing: '0.105px',
      fontWeight: 400,
      padding: theme.spacing(0, 1, 1, 1),
      marginRight: theme.spacing(1),
      '&.Mui-selected': {
        borderBottom: ` 1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
        cursor: 'text',
        pointerEvents: 'unset',
        fontWeight: 500,
      },
    },
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
    '& .MuiTabs-indicator ': {
      display: 'none',
    },
  },
  '& .APDImagesContiner': {
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
  },
}));

export default StyledBox;
